import { makeStyles } from "@fluentui/react-components";
import brandLogo from "../../img/HES-logga-print-on-light.png";
const useStyles = makeStyles({
  logo: {
    height: "40px",
    width: "auto",
  },
});

export const BrandLogo = () => {
  const styles = useStyles();
  return (
    <div>
      <img src={brandLogo} alt="Företagslogotyp" className={styles.logo} />
    </div>
  );
};
